import React from 'react';
import HeaderBar from '../Header and Footer/HeaderBar';
import Footer from '../Header and Footer/Footer';
import ContactFormular from './ContactFormular';

function ContactPage() {
  return (
    <div className="ProductsBody">
      
        <HeaderBar/>
        <ContactFormular/>
      
        
        <Footer/>
    </div>
  );
}

export default ContactPage;
